import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { ChangeEvent, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserCreateDTO } from '../../api/generated';
import { useCreateUserMutation } from '../../api/mutations/user';
import { useUserContext } from '../../UserContext';

export function InviteUser(): ReactElement {
  const { t } = useTranslation();
  const { data: user } = useUserContext();
  const { mutate: createUser, isPending: isSubmitPending } = useCreateUserMutation();

  const [updateData, setUpdateData] = useState<UserCreateDTO>({
    firstName: '',
    lastName: '',
    email: '',
    admin: false,
    organisationId: user?.organisation.id || '',
  });

  const isDataValid = !Object.entries(updateData).some(
    ([key, value]) => typeof value === 'string' && value.length < 3 && key !== 'organisationId'
  );

  // id in TextField component has to match key in newUser state
  function handleDataUpdate(e: ChangeEvent<HTMLInputElement>) {
    const { id, value } = e.target;
    setUpdateData({ ...updateData, [id]: value });
  }

  function handleSubmit() {
    createUser({ data: updateData });
  }

  return (
    <Box display='flex'>
      <TextField
        sx={{ marginRight: 2, flexGrow: 1 }}
        id='firstName'
        label={t('common.form.firstName')}
        value={updateData.firstName}
        onChange={handleDataUpdate}
        fullWidth
      />
      <TextField
        sx={{ marginRight: 2, flexGrow: 1 }}
        id='lastName'
        label={t('common.form.lastName')}
        value={updateData.lastName}
        onChange={handleDataUpdate}
        fullWidth
      />
      <TextField
        sx={{ marginRight: 2, flexGrow: 1 }}
        id='email'
        label={t('common.form.email')}
        value={updateData.email}
        onChange={handleDataUpdate}
        fullWidth
      />
      <Button sx={{ flexGrow: 1 }} variant='contained' onClick={handleSubmit} disabled={!isDataValid} fullWidth>
        {isSubmitPending ? <CircularProgress color='inherit' /> : t('administration.userManagement.inviteUser')}
      </Button>
    </Box>
  );
}
